exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".business-hours p{font-weight:500;margin:0}.business-hours.MuiAccordion-root::before{display:none}.business-hours.MuiPaper-elevation1{box-shadow:none}.business-hours .MuiAccordionSummary-content{flex-grow:0}.business-hours .MuiAccordionDetails-root p{font-size:.93rem}.business-hours .summary-details-business-time{color:#818181;font-size:.87rem !important}.business-hours .summary-details-label{font-size:1rem !important;font-weight:500}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/sass-loader/dist/cjs.js!./src/components/Quoters/Common/Appointment/BusinessHours.scss
// module id = 7562
// module chunks = 13